import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderGroupRepository } from '@/coreInfrastructureModule/interfaces/IOrderGroupRepository';

/**
 * 発注グループ削除を行うユースケース
 */
export class DeleteOrderGroupUseCase {
  private repository: IOrderGroupRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderGroupRepository) {
    this.repository = repository;
  }

  /**
   * 発注グループを削除する
   * @param orderGroupId - 対象の発注ID
   */
  public async execute(orderGroupId: string): Promise<INetworkResult<undefined, Error>> {
    try {
      const networkResult = await this.repository.deleteOrderGroup(orderGroupId);
      switch (networkResult.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
        default:
          return { status: { type: 'error', error: Error('想定外のエラー') } };
      }
    } catch (e) {
      return { status: { type: 'error', error: Error('想定外のエラー') } };
    }
  }
}
